







import { Component, Prop, Vue } from 'vue-property-decorator'
import GroupTagVirtualList from '@/components/Group/GroupTagVirtualList.vue'

type GroupTagItem = {
  id: string | number
  name?: string
  [key: string]: unknown
}

@Component({
  components: {
    GroupTagVirtualList
  }
})
export default class SelectedGroupTagVirtualList extends Vue {
  @Prop({ default: () => [] }) private items!: GroupTagItem[]
}
